// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OyUQeYsHq7wq3wMDWZtb{padding:2px 0 0 4px}.Qy_ufnm0qXIJU254ADrZ{position:relative}.Wg_hGauwTogB3M4yfEOI{color:var(--content-destructive-secondary);align-items:center;gap:4px;padding:4px 4px 4px 8px;display:flex}.iFFmFYIn8Os4MagHMTdt{align-items:center;gap:8px;padding:6px;display:flex}.pna_Y7eYIE8wdpuo71DB{color:var(--purple-100)}.ZTYer5kMcJvvDi2_d4_k{margin:0 0 -12px -15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `OyUQeYsHq7wq3wMDWZtb`,
	"tabs": `Qy_ufnm0qXIJU254ADrZ`,
	"failed": `Wg_hGauwTogB3M4yfEOI`,
	"inProgress": `iFFmFYIn8Os4MagHMTdt`,
	"inProgress__text": `pna_Y7eYIE8wdpuo71DB`,
	"inProgressText": `pna_Y7eYIE8wdpuo71DB`,
	"scroll": `ZTYer5kMcJvvDi2_d4_k`
};
export default ___CSS_LOADER_EXPORT___;
